import { Router } from '@angular/router';
import { Output } from '@angular/core';
import { Component, EventEmitter } from '@angular/core';
import { HandsetService } from '../../../core/services/handset.service';

@Component({
standalone: false,
  selector: 'app-notifications-container-empty-state',
  styleUrls: ['./notifications-container-empty-state.component.scss'],
  templateUrl: './notifications-container-empty-state.component.html',
})
export class NotificationsContainerEmptyStateComponent {
  @Output() public handleClose = new EventEmitter<void>();

  constructor(public handsetService: HandsetService, private router: Router) {}

  public redirectToSettings() {
    this.router.navigate(['settings']).finally(() => this.handleClose.next());
  }
}
